import request from './request'

const enterpriseApi = {
  listEnterprise (params) {
    return request.get('/enterprises', { params: params })
  },
  saveEnterprise (data) {
    return request.post('/enterprise', data)
  },
  updateEnterprise (id, data) {
    return request.put('/enterprises/' + id, data)
  },
  deleteEnterprise (id) {
    return request.delete('/enterprises/' + id)
  },
}

export default enterpriseApi
